import React from "react";
import { LegalLayout, Section } from "@/components/legal/LegalLayout";

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-[color:var(--sg-fg)] leading-relaxed">{children}</p>
);

export const SecurityPage: React.FC = () => (
  <LegalLayout
    testId="page-security"
    title="Security"
    subtitle="How SociBaba protects your workspace and content."
    lastUpdated="February 13, 2026"
    seoPath="/security"
    seoDescription="SociBaba's security posture — bcrypt password hashing, Fernet-encrypted OAuth tokens, TLS in transit, hardened OAuth flows."
    seoKeywords={["security","bcrypt","OAuth token encryption","TLS","CSRF","SociBaba security"]}
  >
    <Section n={1} title="Authentication">
      <P>
        Passwords are hashed with bcrypt (12 rounds). Google sign-in is delegated to Google OAuth 2.0 — we never see your Google password. Session tokens are stored as HTTP-only cookies (Google Auth) or short-lived JWTs (email/password).
      </P>
    </Section>
    <Section n={2} title="Data at rest">
      <P>
        MongoDB is hosted on a managed service with encryption at rest. OAuth tokens are additionally encrypted with a per-installation Fernet key before being written to the database.
      </P>
    </Section>
    <Section n={3} title="Data in transit">
      <P>All traffic between your browser and SociBaba is served over TLS 1.2+.</P>
    </Section>
    <Section n={4} title="Media storage">
      <P>
        Uploaded media is stored in Emergent's Object Storage. Raw upload files are auto-deleted after successful publish; only thumbnails and metadata are retained.
      </P>
    </Section>
    <Section n={5} title="Reporting a vulnerability">
      <P>
        Email <a className="text-[color:var(--sg-primary)] hover:underline" href="mailto:security@socibaba.com">security@socibaba.com</a>. We acknowledge reports within 48 hours.
      </P>
    </Section>
  </LegalLayout>
);

export default SecurityPage;
